import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

import useConfirmDiscard from './useConfirmDiscard';

// Guards a page holding unsaved changes: an in-app navigation asks for confirmation first, and closing
// or reloading the browser tab triggers the browser's own warning. Requires the data router
// (createBrowserRouter), so it is called from the route components, not from the views.
const useUnsavedChangesBlocker = (when) => {
    const blocker = useBlocker(when);
    const confirmDiscard = useConfirmDiscard();
    const confirmationShown = useRef(false);

    useEffect(() => {
        if (blocker.state !== 'blocked') {
            confirmationShown.current = false;
            return;
        }
        if (confirmationShown.current) return;
        confirmationShown.current = true;
        confirmDiscard({ onConfirm: () => blocker.proceed(), onCancel: () => blocker.reset() });
    }, [blocker, confirmDiscard]);

    useEffect(() => {
        if (!when) return undefined;
        const warn = (event) => {
            event.preventDefault();
            // Older browsers only show the warning when returnValue is set.
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', warn);
        return () => window.removeEventListener('beforeunload', warn);
    }, [when]);
};

export default useUnsavedChangesBlocker;
